export const substrWithDots = (text?: string, numberOfChar = 100) => {
  if (text === undefined) return '';
  if (text.length < numberOfChar) return text;
  const splittedText = text.split(' ');

  while (splittedText.join('').length + splittedText.length > numberOfChar) splittedText.pop();

  return splittedText.join(' ').replace(new RegExp(`^(.{${numberOfChar}}).*`), '$1') + ' ...';
};
